/* NEXSORA SunsetGlow: colour preview + scroll-pinned scenes. Shared scroll/cart/gallery code lives in sg-galaxy.js */
(function () {
  'use strict';
  if (window.__ssLoaded) return;
  window.__ssLoaded = true;
  var mqR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var lastScroll = 0;
  window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
  var idle = function () { return Date.now() - lastScroll > 250; };

  /* Colour preview: purely visual. Fades the glow behind the lamp to the chosen swatch colour. */
  function initColors(sec) {
    if (sec.__ssc) return; sec.__ssc = 1;
    var sw = qsa('.ss-sw button', sec), label = qs('[data-ss-label]', sec);
    var wash = qs('.ss-wash', sec), halo = qs('.ss-halo', sec);
    var cur = -1, timer = 0, visible = false, stopped = false;
    function pick(i) {
      i = (i + sw.length) % sw.length;
      if (i === cur) return;
      cur = i;
      var c = sw[i].getAttribute('data-c');
      sw.forEach(function (b, n) { b.setAttribute('aria-checked', n === i ? 'true' : 'false'); });
      sec.style.setProperty('--ss-c', c);
      if (wash) wash.style.backgroundColor = c;
      if (halo) halo.style.backgroundColor = c;
      if (label) label.textContent = 'Preview ' + (i + 1) + ' of ' + sw.length;
    }
    function stop(forever) { clearInterval(timer); timer = 0; if (forever) stopped = true; }
    function start() {
      if (mqR.matches || stopped || timer || !visible) return;
      timer = setInterval(function () { if (idle()) pick(cur + 1); }, 2800);
    }
    sw.forEach(function (b, n) { b.addEventListener('click', function () { pick(n); stop(true); }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); else stop(false); }).observe(sec);
    }
    pick(0);
  }

  /* Scenes advance as the page scrolls through a pinned stage (only while on screen) */
  function initPin(sec) {
    if (sec.__ssp) return; sec.__ssp = 1;
    var scenes = qsa('.sg-scene', sec), tabs = qsa('.sg-tab', sec), idx = -1, ticking = false, near = false;
    function show(i) {
      if (i === idx) return; idx = i;
      scenes.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
    }
    function frame() {
      ticking = false;
      if (mqR.matches || !near) return;
      var r = sec.getBoundingClientRect(), span = r.height - window.innerHeight;
      var p = span > 0 ? -r.top / span : 0;
      p = p < 0 ? 0 : p > 0.999 ? 0.999 : p;
      show(Math.floor(p * scenes.length));
    }
    function req() { if (!ticking && near) { ticking = true; requestAnimationFrame(frame); } }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { near = en[0].isIntersecting; req(); }, { rootMargin: '20% 0px' }).observe(sec);
    } else { near = true; }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req, { passive: true });
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        if (mqR.matches) { show(n); return; }
        var top = sec.getBoundingClientRect().top + window.pageYOffset;
        var span = sec.offsetHeight - window.innerHeight;
        window.scrollTo({ top: top + span * ((n + 0.5) / scenes.length), behavior: 'smooth' });
      });
    });
    show(0);
  }

  function init(scope) {
    qsa('[data-ss-colors]', scope).forEach(initColors);
    qsa('[data-ss-pin]', scope).forEach(initPin);
  }
  if (document.readyState !== 'loading') init(document); else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();